/* eslint-disable max-len */
import React, { useState } from 'react';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import Backdrop from '@mui/material/Backdrop';
import { ThemeProvider } from '@mui/material/styles';
import {
  LogoutOutlined,
  NotificationsNoneOutlined,
  PowerSettingsNew,
  ShareOutlined,
} from '@mui/icons-material';
import { Colors } from '../../theme';
import { AlertDialog } from '../AlertDialog';
import { themeSpeedDial } from '../../pages/MapPage/styles';
import { useVehiclesService } from '../../hooks';
import { loaderService } from '../../services';
import { notificationSettingsHint } from '../../utils';


const actions = [
  { icon: <PowerSettingsNew />, name: 'Encender/Apagar Vehículo' },
];

const alertDialogTitles = [
  {
    title: 'Apagado remoto',
    subtitle: '¿Desea apagar este vehiculo de forma remota?',
  },
  {
    title: 'Encendido remoto',
    subtitle: '¿Desea encender este vehiculo de forma remota?',
  },
];
const mainbuttonTitle = 'Aceptar';
const secondarybuttonTitle = 'Cancelar';
const titleUrl = '¡Copia la URL y compartela!';
const copiedTitle = '¡Copiado, Ahora compartela!';

// Las notificaciones del navegador solo existen en computador (useBrowserNotifications).
const notificationHelp = {
  denied: {
    title: 'Notificaciones bloqueadas',
    subtitle: 'Haz clic en el candado junto a la dirección de la página, entra a Configuración del sitio y permite Notificaciones.',
  },
};

const testSentInfo = () => ({
  title: 'Te enviamos una notificación de prueba',
  subtitle: notificationSettingsHint(),
});


function MenuMap({
  selectedVehicleData,
  userLogout,
  sharePosition,
  urlShare,
  notificationPermission,
  enableNotifications,
}) {
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openUrl, setOpenUrl] = useState(false);
  const [copied, setCopied] = useState(false);
  const [relayState, setRelayState] = useState(null);
  const [notificationInfo, setNotificationInfo] = useState(null);

  const { 
    checkStatusRelay, writeMessageWS, turnOffVehicle, turnONVehicle, 
  } = useVehiclesService();

  const handleTurnOffOn = async () => {
    if (relayState === 0) {
      await turnOffVehicle(selectedVehicleData[0].vehiculo.Chasis);
    } else if (relayState === 1) {
      await turnONVehicle(selectedVehicleData[0].vehiculo.Chasis);
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenAlert = async () => {
    let sum = 0;
    setRelayState(null);
    const { success } = await writeMessageWS(selectedVehicleData[0].Chasis, 'get', 4);
    if (success === 1) {
      loaderService.show();
      const interval = setInterval(async () => {
        sum += 1;
        const { relay } = await checkStatusRelay(selectedVehicleData[0].Chasis);
        if (relay !== null) {
          clearInterval(interval);
          loaderService.hide();
          setRelayState(relay);
          setOpenAlert(true);
        }

        if (sum === 10) {
          loaderService.hide();
          clearInterval(interval);
        }
      }, 2000);
    }
  };
  const handleCloseAlert = () => {
    setOpenAlert(false);
    setOpenUrl(false);
    setCopied(false);
  };
  const handleAceptAlert = () => {
    handleCloseAlert();
    handleTurnOffOn();
  };
  const handleOpenUrl = () => {
    setOpenUrl(true);
    sharePosition();
  };

  // Sin soporte (celulares) o ya activadas: la opción no aparece en el menú.
  const canAskNotifications = notificationPermission === 'default'
    || notificationPermission === 'denied';

  const handleNotifications = async () => {
    handleClose();
    const result = await enableNotifications();
    if (result === 'granted') {
      setNotificationInfo(testSentInfo());
      return;
    }
    setNotificationInfo(notificationHelp[result] || null);
  };

  const handleCloseNotificationInfo = () => setNotificationInfo(null);

  const handleCopytext = () => {
    navigator.clipboard.writeText(urlShare);
    setCopied(true);
  };

  const validation = selectedVehicleData !== null;
  // Sin posición (moto sin GPS) no hay dispositivo que encender ni ubicación que compartir.
  const hasVehicleData = Boolean(selectedVehicleData?.[0]);

  const selectTitle = () => {
    let title;
    let subtitle;
    if (validation) {
      title = relayState === 0
        ? alertDialogTitles[0].title
        : alertDialogTitles[1].title;
      subtitle = relayState === 0
        ? alertDialogTitles[0].subtitle
        : alertDialogTitles[1].subtitle;
      return [title, subtitle];
    }
  };
  const selected = selectTitle();

  return (
    <>
      <AlertDialog
        mainbuttonTitle="Copiar Url"
        secondarybuttonTitle="Cerrar"
        selectedVehicleData={selectedVehicleData}
        handleAceptAlert={handleCopytext}
        handleCloseAlert={handleCloseAlert}
        handleCancelAlert={handleCloseAlert}
        openAlert={openUrl}
        title={copied ? copiedTitle : titleUrl}
        subtitle={urlShare}
      />
      <AlertDialog
        mainbuttonTitle={mainbuttonTitle}
        secondarybuttonTitle={secondarybuttonTitle}
        selectedVehicleData={selectedVehicleData}
        handleAceptAlert={handleAceptAlert}
        handleCloseAlert={handleCloseAlert}
        handleCancelAlert={handleCloseAlert}
        openAlert={openAlert}
        title={selected ? selected[0] : null}
        subtitle={selected ? selected[1] : null}
      />
      <AlertDialog
        mainbuttonTitle="Entendido"
        selectedVehicleData={{}}
        handleAceptAlert={handleCloseNotificationInfo}
        handleCloseAlert={handleCloseNotificationInfo}
        openAlert={Boolean(notificationInfo)}
        title={notificationInfo?.title}
        subtitle={notificationInfo?.subtitle}
      />
      <ThemeProvider theme={themeSpeedDial}>
        <Backdrop open={open} sx={{ color: Colors.BACKGROUND_CIAN }} />
        <SpeedDial
          ariaLabel="menu"
          sx={{ position: 'absolute', bottom: 120, right: 16 }}
          icon={<SpeedDialIcon />}
          onClose={handleClose}
          onOpen={handleOpen}
          open={open}
        >
          {hasVehicleData ? actions.map((action) => (
            <SpeedDialAction
              color="secondary"
              key={action.name}
              icon={action.icon}
              tooltipOpen
              onClick={handleOpenAlert}
              tooltipTitle={action.name}
            />
          )) : null}
          {hasVehicleData ? (
            <SpeedDialAction
              color="secondary"
              key="Compartir Ubicación"
              icon={<ShareOutlined />}
              tooltipOpen
              tooltipTitle="Compartir Ubicación"
              onClick={handleOpenUrl}
            />
          ) : null}
          {canAskNotifications ? (
            <SpeedDialAction
              color="secondary"
              key="Notificaciones"
              icon={<NotificationsNoneOutlined />}
              tooltipOpen
              tooltipTitle="Activar notificaciones"
              onClick={handleNotifications}
            />
          ) : null}
          <SpeedDialAction
            color="secondary"
            key="Cerrar Sesión"
            icon={<LogoutOutlined />}
            tooltipOpen
            tooltipTitle="Cerrar Sesión"
            onClick={userLogout}
          />
        </SpeedDial>
      </ThemeProvider>
    </>
  );
}

export { MenuMap };
